import React, {Component} from 'react'
import PrintPreview from '../PrintPreview'
import PdfStore from '../../../stores/PdfStore'
import './Print.css'

var NotificationSystem = require('react-notification-system');
const DEFAUT_ROW = 19
class PrintZongInvoiceDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,data:{itemlist:this.newEmptyRow(DEFAUT_ROW)},page_title:'กำลังดึงข้อมูล..',defaultTypePrint:'3',dataList:[]}
    
    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem
    this.loadData()
  }

  newEmptyRow(number){
  	let emptyRow = {}
  	if (this.props.doc==='invoice_doc')
  		emptyRow = {amount:'',bf_invoice_item_id:'',detail:'',discount:'',invoice_no:'',price_per_unit:'',quantity:'',seq:''}
  	else if (this.props.doc==='taxinvoice_doc')
  		emptyRow = {amount:'',bf_taxinvoice_item_id:'',detail:'',discount:'',taxinvoice_no:'',price_per_unit:'',quantity:'',seq:''}

    return new Array(number).fill(null).map((item,index)=>{
      return emptyRow
    })
  }

  loadData() {
  	let {data} = this.state
  	this.setState({loading:true})
 	PdfStore.loadBNPDoc(this.props.doc,this.props.param,this.props.ivNo,(result)=>{
        data = result.data
 		if (data.itemlist!==undefined&&data.itemlist.length>0) {
            if (data.itemlist.length<13)
                data.itemlist = data.itemlist.concat(this.newEmptyRow(13-data.itemlist.length))
        }
 		this.setState({loading:true,data:data,dataList:this.getPagination(data.itemlist)})
 	})
  }

  renderLogoUrl(logoUrl){
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    if(logoUrl!==undefined)
      return (<img src={imgUrl} />)
    else
      return ('')
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummaryDiscount() {
  	let {data} = this.state
  	let sum = 0
  	data.itemlist.forEach(function(item,index) {
  		let discount = item.discount
  		if (discount===''||discount===null||discount===undefined||isNaN(discount))
  			discount = 0

  		sum += parseFloat(discount)
  	})
  	return sum
  }

  getSummaryAmount() {
  	let {data} = this.state
  	let sum = 0
  	data.itemlist.forEach(function(item,index) {
  		let amount = item.amount
  		if (amount===''||amount===null||amount===undefined||isNaN(amount))
  			amount = 0
  		
  		sum += parseFloat(amount)
  	})
  	sum = sum - this.getSummaryDiscount()
  	return sum
  }

  getVat() {
  	let {data} = this.state
  	let sum = 0
  	if (data.vat_type==='VAT_EXCLUDE') {
  		sum = (this.getSummaryAmount()*7)/100
  		return sum
  	} else if (data.vat_type==='VAT_INCLUDE') {
      sum = (this.getSummaryAmount() * 0.07) 
  		return sum
    } else {
  		return sum
  	}
  }

  getDiscountPercent(discount=0,amount=0) {
  	let sum = (discount*100)/amount
  	return sum
  }

  renderPayBy() {
    return(
      <div>
        <div>ชำระเงินโดย</div>
        <div style={{fontSize:'15px'}}>
          <div style={{display:'inline-flex',width:'20%'}}>
            ( &nbsp;&nbsp; ) เงินสด (Cash)
          </div>
          <div style={{display:'inline-flex',width:'25%'}}>
            ( &nbsp;&nbsp; ) โอนเงิน (Transfer)
          </div>
          <div style={{display:'inline-flex',width:'55%'}}>
            ( &nbsp;&nbsp; ) เช็ค (Cheque Bank) (ในกรณีชำระด้วยเช็ค โปรดสั่งจ่ายและขีดคร่อมในนามบริษัทเท่านั้น)
          </div>
        </div>
        <br />
        <div style={{fontSize:'16px'}}>
          <div style={{display:'inline-flex',width:'20%'}}>
            
          </div>
          <div style={{display:'inline-flex',width:'80%'}}>
            ธนาคาร................................สาขา................................เลขที่................................วันที่................................
          </div>
        </div>
      </div>
    )
  }

  renderSignature() {
    return(
      <div>    
        <div style={{width:'25%',display:'inline-flex'}}>
          <table className='table table-ssr-general-doc'>
            <tbody>
              <tr>
                <td className='text-left bb-h'>ได้รับสินค้าตามรายการถูกต้องแล้ว</td>
              </tr>
              <tr>
                <td className='text-left bt-h bb-h'>ผู้รับของ / Receiver</td>
              </tr>
              <tr>
                <td className='text-center bt-h bb-h'>..............................</td>
              </tr>
              <tr>
                <td className='text-center bt-h'>วันที่........../........../...........</td>
              </tr>  
            </tbody>
          </table>
        </div>
        <div style={{width:'25%',display:'inline-flex'}}>
          <table className='table table-ssr-general-doc'>
            <tbody>
              <tr>
                <td className='text-center bb-h'>ผู้ส่งของ</td>
              </tr>
              <tr>
                <td className='text-left bt-h bb-h'><br /></td>
              </tr>
              <tr>
                <td className='text-center bt-h bb-h'>..............................</td>
              </tr>
              <tr>
                <td className='text-center bt-h'>วันที่........../........../...........</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{width:'25%',display:'inline-flex'}}>
          <table className='table table-ssr-general-doc'>
            <tbody>
              <tr>
                <td className='text-center bb-h'>ผู้รับเงิน / Collector</td>
              </tr>
              <tr>
                <td className='text-left bt-h bb-h'><br /></td>
              </tr>
              <tr>
                <td className='text-center bt-h bb-h'>..............................</td>
              </tr>
              <tr>
                <td className='text-center bt-h'>วันที่........../........../...........</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{width:'25%',display:'inline-flex'}}>
          <table className='table table-ssr-general-doc'>
            <tbody>
              <tr>
                <td className='text-center bb-h'>ผู้มีอำนาจลงนาม/Authorized by</td>
              </tr>
              <tr>
                <td className='text-left bt-h bb-h'><br /></td>
              </tr>
              <tr>
                <td className='text-center bt-h bb-h'>..............................</td>
              </tr>
              <tr>
                <td className='text-center bt-h'>วันที่........../........../...........</td>
              </tr>
            </tbody>
          </table>
        </div>      
      </div>       
    )
  }

  renderBody(itemlist,itemIndex) {
    let {data} = this.state
    return(
      <div>
        <div style={{width:'60%',display:'inline-flex'}}>
          <table className='table table-ssr-general-doc' style={{height:100}}>
            <tbody>
              <tr>
                <td style={{width:'200px'}} className='text-left br-h bb-h'>นามลูกค้า/Name</td>
                <td className='bb-h bl-h' style={{width:'500px'}}>{data.customer_name===null||data.customer_name===undefined?'':data.customer_name}</td>
              </tr>
              <tr>  
                <td className='text-left br-h bb-h bt-h'>ที่อยู่/Address</td>
                <td className='bb-h bt-h bl-h'>{data.customer_address===null||data.customer_address===undefined?'':data.customer_address}</td>
              </tr>
              <tr>  
                <td className='text-left bt-h br-h bt-h'>เลขประจำตัวผู้เสียภาษี</td>
                <td className='bt-h bl-h'>{data.customer_tax} / {data.customer_branch}</td>
              </tr>
            </tbody>
          </table>    
        </div>
        <div style={{width:'40%',display:'inline-flex'}}>
          <table className='table table-ssr-general-doc' style={{height:100}}>
            <tbody>
              <tr>
                <td style={{width:'500px'}} className='text-left br-h bb-h'>วันที่ (Date)</td>
                <td className='bb-h bl-h' style={{width:'300px'}}>{data.doc_date===null||data.doc_date===undefined?'':data.doc_date}</td>
              </tr>
              <tr>
                <td className='text-left br-h bb-h bt-h'>เลขที่ใบกำกับ (No.)</td>
                <td className='bb-h bt-h bl-h'>{data.doc_no===null||data.doc_no===undefined?'':data.doc_no}</td>
              </tr>
              <tr>  
                <td className='text-left br-h bb-h bt-h'>กำหนดชำระเงิน (Term)</td>
                <td className='bb-h bt-h bl-h'></td>
              </tr>
              <tr>  
                <td className='text-left br-h bb-h bt-h'>ครบกำหนด (Due Date)</td>
                <td className='bb-h bt-h bl-h'>{data.due_date===null||data.due_date===undefined?'':data.due_date}</td>
              </tr>
              <tr>  
                <td className='text-left bt-h br-h bt-h'>อ้างอิงใบแจ้งหนี้เลขที่ (Ref. No)</td>
                <td className='bt-h bl-h'></td>
              </tr>
            </tbody>
          </table>
        </div>  
        {this.renderTable(itemlist,itemIndex)}
        {this.renderPayBy()}
        <br />
        {this.renderSignature()}
      </div>
    )
  }    

  renderTable(itemlist,itemIndex) {
    let {data} = this.state
    return(
      <div>  
  		  <table className='table table-ssr-general-doc'>
	        <tbody>
	          <tr>
	            <td style={{width:'50px'}} className='text-center br-h bb-h'>ลำดับ <br /> No.</td>
	            <td style={{width:'500px'}} className='text-center br-h bb-h'>รายการ <br /> Description</td>
	            <td style={{width:'120px'}} className='text-center br-h bb-h'>ราคาต่อหน่วย <br/>Unit Price</td>
	            <td style={{width:'100px'}} className='text-center br-h bb-h'>จำนวน <br/> Quantity</td>
	            <td style={{width:'120px'}} className='text-center bb-h'>จำนวนเงิน <br/> Amount</td>
	          </tr>
	          {this.renderRowData(itemlist,itemIndex)}
            <tr>
              <td className='text-left bt-h br-h' colSpan={2}>
                หมายเหตุ <br />
                Remark {data.remark}
              </td>
              <td className='bt-h br-h text-left' colSpan={2}>
                รวมเงิน <br />
                Subtotal
              </td>
	            <td className='bt-h text-right'>{this.getNumberFormat(this.getSummaryAmount())}</td>
	          </tr>
            <tr>
              <td className='text-left bt-h br-h bbl-radius-8' colSpan={2} rowSpan={2}>
                จำนวนเงินรวมทั้งสิ้น <br />
                Grand Total Amount {(data.grand_total_thai===''||data.grand_total_thai===null||data.grand_total_thai===undefined?'( ศูนย์บาทถ้วน )':'( '+data.grand_total_thai+' )')}
              </td>
              <td className='bt-h br-h text-left' colSpan={2}>
                ภาษีมูลค่าเพิ่ม <br />
                VAT
              </td>
	            <td className='bt-h text-right'>{this.getNumberFormat(this.getVat())}</td>
	          </tr>
            <tr>
              <td className='text-left bt-h br-h bbl-radius-0' colSpan={2}>
                ยอดเงินสุทธิ <br />
                Total
              </td>
	            <td className='bt-h text-right'>{this.getNumberFormat(data.amount)}</td>
	          </tr>
	        </tbody>
	      </table>
      </div>    
  	)
  }

  renderRowData(itemlist,itemIndex) {
  	return(
        itemlist.data.map((item,index)=>{
  			return(
  				<tr key={index}>
  					<td className={'text-center br-h '+(index>0?'bt-h':'')}>{item.seq===''?<br/>:index+1}</td>
            <td className={index>0?'bt-h br-h':'br-h'}>{item.seq===''?'':item.detail}</td>
  					<td className={'text-right br-h '+(index>0?'bt-h':'')}>{item.seq===''||item.quantity==='0'||item.quantity===''?'':this.getNumberFormat(item.price_per_unit)}</td>
  					<td className={'text-center br-h '+(index>0?'bt-h':'')}>{item.seq===''||item.quantity==='0'||item.quantity===''?'':this.getNumberFormat(item.quantity)}</td>
  					<td className={'text-right '+(index>0?'bt-h':'')}>{item.seq===''||item.quantity==='0'||item.quantity===''?'':this.getNumberFormat(item.amount)}</td>
  				</tr>
  			)
  		})
  	)
  }

  renderComponentPage(itemlist,itemIndex) {
    let {data,defaultTypePrint} = this.state
    let comEn = (typeof data.company_en!=='undefined'?data.company_en:data)
    return(
      <div className='font-print print-zong-parking-car-doc' key={itemIndex}>
        <div>
	        <div style={{display:'inline-flex'}}>
            <div style={{width:'40%'}}>
              <section className="font-16">
                <strong>
                  <p style={{lineHeight:'0.7'}}>{data.company_name}</p>           
                  <p style={{lineHeight:'0.7'}}>{data.company_addr}</p>
                  <p style={{lineHeight:'0.7'}}>โทร {data.company_tel}</p>
                  <p style={{lineHeight:'0.7'}}>โทรสาร {data.company_fax}</p>
                  <p style={{lineHeight:'0.7'}}>เลขประจำตัวผู้เสียภาษี {data.company_tax} {data.company_branch}</p>                           
                </strong>
              </section>
            </div>
            <div className='text-center' style={{width:'20%'}}>
              {this.renderLogoUrl(data.logo_url)}  
            </div>  
            <div className='text-right' style={{width:'40%'}}>
              <section className="font-16">
                <strong>
                  <p style={{lineHeight:'0.7'}}>{comEn.company_name}</p>           
                  <p style={{lineHeight:'0.7'}}>{comEn.company_addr}</p>
                  <p style={{lineHeight:'0.7'}}>Tel. {comEn.company_tel}</p>
                  <p style={{lineHeight:'0.7'}}>FAX {comEn.company_fax}</p>
                  <p style={{lineHeight:'0.7'}}>Tax ID : {comEn.company_tax} {comEn.company_branch}</p>                           
              </strong>
              </section>
            </div>
          </div>
          <div className='text-right'>
            <header>
              <h2 className="text-right">{this.props.title}</h2>
              <br />
              <h2 className='sec-copy-doc' style={{width:'auto',display:defaultTypePrint=='0'?'none':''}}>
                {itemlist.type=='ori'?'ต้นฉบับ (ORIGINAL)':itemlist.type=='copy'?'สำเนา (COPY)':''}
              </h2>
              <p style={{lineHeight:'0.7'}}>เอกสารออกเป็นชุด</p>
            </header>
          </div>
	        {this.renderBody(itemlist.data,itemIndex)}
	      </div>
      </div>  
    )
  }

  onTypePrintChange(e) {
  	this.setState({defaultTypePrint:e})  
  }

  getPagination(data) {
    let checkRow = 0
    let newData = []
    let allData = []
    let summary = {sum:false,sum1:false,sum2:false,sum3:false,sum4:false,sum5:false}
      
    data.forEach((item,index)=>{
      if (checkRow<DEFAUT_ROW) {
        newData.push(item)
      }
      if (checkRow==DEFAUT_ROW-1||index==data.length-1) {
        allData.push({
          data:newData,
          summary:summary
        })
        newData = []
        checkRow = -1
      }
      checkRow++
    })
    
    if (allData.length>0) {
        if (DEFAUT_ROW-allData[allData.length-1].data.length>=6) {
            allData[allData.length-1].data = allData[allData.length-1].data.concat(this.newEmptyRow(DEFAUT_ROW-(allData[allData.length-1].data.length+6)))
            allData[allData.length-1].summary = {sum:true,sum1:true,sum2:true,sum3:true,sum4:true,sum5:true}
        } else if (DEFAUT_ROW-allData[allData.length-1].data.length>4&&DEFAUT_ROW-allData[allData.length-1].data.length<=5) {
            allData[allData.length-1].summary = {sum:true,sum1:true,sum2:true,sum3:true,sum4:true,sum5:false}
            allData.push({
                data:this.newEmptyRow(DEFAUT_ROW-1),
                summary:{sum:false,sum1:false,sum2:false,sum3:false,sum4:false,sum5:true}
            })
        } else if (DEFAUT_ROW-allData[allData.length-1].data.length>3&&DEFAUT_ROW-allData[allData.length-1].data.length<=4) {
            allData[allData.length-1].summary = {sum:true,sum1:true,sum2:true,sum3:true,sum4:false,sum5:false}
            allData.push({
                data:this.newEmptyRow(DEFAUT_ROW-2),
                summary:{sum:false,sum1:false,sum2:false,sum3:false,sum4:true,sum5:true}
            })
        } else if (DEFAUT_ROW-allData[allData.length-1].data.length>2&&DEFAUT_ROW-allData[allData.length-1].data.length<=3) {
            allData[allData.length-1].summary = {sum:true,sum1:true,sum2:true,sum3:false,sum4:false,sum5:false}
            allData.push({
                data:this.newEmptyRow(DEFAUT_ROW-3),
                summary:{sum:false,sum1:false,sum2:false,sum3:true,sum4:true,sum5:true}
            })
        } else if (DEFAUT_ROW-allData[allData.length-1].data.length>1&&DEFAUT_ROW-allData[allData.length-1].data.length<=2) {
            allData[allData.length-1].summary = {sum:true,sum1:true,sum2:false,sum3:false,sum4:false,sum5:false}
            allData.push({
                data:this.newEmptyRow(DEFAUT_ROW-4),
                summary:{sum:false,sum1:false,sum2:true,sum3:true,sum4:true,sum5:true}
            })
        } else if (DEFAUT_ROW-allData[allData.length-1].data.length>0&&DEFAUT_ROW-allData[allData.length-1].data.length<=1) {
            allData[allData.length-1].summary = {sum:true,sum1:false,sum2:false,sum3:false,sum4:false,sum5:false}
            allData.push({
                data:this.newEmptyRow(DEFAUT_ROW-5),
                summary:{sum:false,sum1:true,sum2:true,sum3:true,sum4:true,sum5:true}
            })
        } else if (DEFAUT_ROW-allData[allData.length-1].data.length<=0) {
            allData.push({
                data:this.newEmptyRow(DEFAUT_ROW-6),
                summary:{sum:true,sum1:true,sum2:true,sum3:true,sum4:true,sum5:true}
            })
        }    
    }    
    
    return allData
  }
  
  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  setPageRender(dataList,defaultTypePrint) {
    let pages = []
    dataList.forEach((item,index)=>{
        if (defaultTypePrint=='1'||defaultTypePrint=='3'||defaultTypePrint=='0') {
            pages.push({
                page:index+1,
                type:'ori',
                data:item
            })
        } else if (defaultTypePrint=='2') {
            pages.push({
                page:index+1,
                type:'copy',
                data:item
            })
        }
    })
    if (defaultTypePrint=='3'||defaultTypePrint=='0') {
        pages.forEach((item,index)=>{
            pages.push({
                page:pages[pages.length-1].page+1,
                type:'copy',
                data:item.data
            })
        })
    }
    return pages
  }

  render() {
    let {loading,dataList,defaultTypePrint} = this.state
    let pages = this.setPageRender(dataList,defaultTypePrint)
    
    if (dataList.length==0) {
        return(
          <PrintPreview
            loading={loading}
            leftBarTitle={this.props.title}
          >  
            {this.renderNoData()}
          </PrintPreview>  
        )
      } else {
        return(
            <div>
                <PrintPreview
                    loading={loading}
                    leftBarTitle={this.props.title}
                    onTypePrintChange={this.onTypePrintChange.bind(this)}
                    defaultTypePrint={this.state.defaultTypePrint}
                    showPageNumber={false}
                >
                    {
                    pages.map((item,index) => {
                        return(
                        this.renderComponentPage(item,index)
                        )
                    }) 
                    }
                </PrintPreview>
                <NotificationSystem ref="notificationSystem" />
            </div>
            ) 
        }
    }    
}  

PrintZongInvoiceDoc.defaultProps = {
  mode: '1',
  title:'ใบกำกับภาษี/ใบเสร็จรับเงิน (TAX INVOICE/RECEIPT)',
  doc:'invoice_doc',
  param:'iv'
}
export default PrintZongInvoiceDoc;


// WEBPACK FOOTER //
// ./src/view/print/zong/PrintZongInvoiceDoc.js